import { object, string } from 'yup';
const NBSSchema = object({
  firstName: string().required('Please provide a valid first name').matches(/^[A-Za-z&.\s-,']+$/g, 'Please provide a valid first name'),
  middleName: string().notRequired().matches(/^[A-Za-z&.\s-,']*$/g, 'Please provide a valid middle name'),
  lastName: string().required('Please provide a valid last name').matches(/^[A-Za-z&.\s-,']+$/g, 'Please provide a valid last name'),
  email: string().email('Please provide a valid email address').required('Please provide a valid email address'),
  phone: string().required('Please provide a valid phone number').min(10, 'Please provide a valid phone number').max(10, 'Please provide a valid phone number'),
  borrower: string().required('Please select borrower'),
  street: string().when('propertyAddress', {
    is: value => Array.isArray(value) && value.length === 0,
    then: schema => schema.required('Please provide a valid street address')
  }),
  unit: string().nullable().when('propertyAddress', {
    is: value => Array.isArray(value) && value.length === 0,
    then: schema => schema.notRequired().matches(/^$|[A-Za-z1-9]+$/g, 'Please provide a valid unit number')
  }),
  cityName: string().when('propertyAddress', {
    is: value => Array.isArray(value) && value.length === 0,
    then: schema => schema.required('Please provide valid city')
  }),
  stateCode: string().when('propertyAddress', {
    is: value => Array.isArray(value) && value.length === 0,
    then: schema => schema.required('Please select state')
  }),
  postalCode: string().when('propertyAddress', {
    is: value => Array.isArray(value) && value.length === 0,
    then: schema => schema.required('Please provide valid zip code').min(5, 'Please provide valid zip code').max(5, 'Please provide valid zip code').matches(/^[0-9]+$/, 'Please provide valid zip code')
  })
});
export default NBSSchema;
//# sourceMappingURL=index.js.map